import React from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import TotalModalWrapper from '../../Model/Share/Normal/TotalModalWrapper';

import WhiteNote from '../../image/WhiteNote.png';

export default function WodDeleteModal(props) {
  const { onClickExit, onClickDelete } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  return (
    <TotalModalWrapper>
      <ModalView>
        <RedTrashBoxWrapper>
          <RedTrashBox>
            <TrashImage src={WhiteNote} />
          </RedTrashBox>
        </RedTrashBoxWrapper>
        <TotalWrapper>
          <Title>{t('note.exercise.deleteProgram')}</Title>
          <TextWrapper>
            <Explanation>{t('note.exercise.deleteProgramConfirm')}</Explanation>
          </TextWrapper>
        </TotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickExit}>{t('note.button.cancel')}</ExitButton>
          <DeleteButton onClick={onClickDelete}>{t('note.button.delete')}</DeleteButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 8px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const TrashImage = styled.img`
  width: 53px;
  height: 53px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 48px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.buttonFill3};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.white};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKey};
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.buttonFill3};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.white};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
  }
`;
